import type { EndUserLibraryInfoSW, EndUserSettings } from "./euscp/euscp"
import EUSignLibrary from "./EUSignLibrary"
import { loadEuscpScript } from "./loadEuscpScript"

// The library is a hardware key media reader (SignWeb library type) — it
// talks to the native ІІТ sign-agent installed on the user's machine rather
// than handling private keys in-browser, so no euscp.worker(.ex).js is
// needed here (that's only for the JavaScript/file-key library type).
const settings: EndUserSettings = {
  language: "uk",
  encoding: "utf-8",
  httpProxyServiceURL: "",
  directAccess: true,
  CAs: "/euscp/Data/CAs.json",
  CACertificates: "/euscp/Data/CACertificates.p7b",
}

export default class EUSignLibraryLoader {
  async load(): Promise<EUSignLibrary> {
    try {
      await loadEuscpScript()

      const library = new window.EndUser(
        undefined,
        window.EndUserConstants.EndUserLibraryType.SW
      )

      const info = (await library.GetLibraryInfo()) as EndUserLibraryInfoSW
      if (!info.supported) {
        throw new Error(
          "Бібліотека web-підпису не підтримується в цьому браузері або ОС"
        )
      }
      if (!info.loaded) {
        if (info.isNativeLibraryNeedUpdate) {
          throw new Error(
            `Бібліотека web-підпису потребує оновлення: ${info.nativeLibraryUpdateURL}`
          )
        }
        if (info.isWebExtensionSupported && !info.isWebExtensionInstalled) {
          throw new Error(
            `Бібліотека web-підпису потребує встановлення розширення браузера: ${info.webExtensionInstallURL}`
          )
        }
        throw new Error(
          `Бібліотека web-підпису потребує встановлення: ${info.nativeLibraryInstallURL}`
        )
      }

      const isInitialized = await library.IsInitialized()
      if (!isInitialized) {
        await library.Initialize(settings)
      }

      return new EUSignLibrary(library)
    } catch (error) {
      return new EUSignLibrary(
        undefined,
        error instanceof Error ? error : new Error(String(error))
      )
    }
  }
}
